
import { ITestAwareState, ITestConfiguration, ITestMessages } from "../Contracts";

export function getTestMessages(state: ITestAwareState): ITestMessages | undefined {
    if (!state || !state.testViewState) {
        return undefined;
    }

    return state.testViewState.messages;
}

export function getTestConfig(state: ITestAwareState): ITestConfiguration | undefined {
    if(!state || !state.testViewState) {
        return undefined;
    }

    return state.testViewState.testConfig;
}